var map = {
	"./image_etrac": 23,
	"./image_etrac.png": 23,
	"./image_gap": 24,
	"./image_gap.jpg": 24,
	"./image_gwic": 25,
	"./image_gwic.png": 25,
	"./image_mdc": 26,
	"./image_mdc.jpg": 26,
	"./image_thedogs": 27,
	"./image_thedogs.jpg": 27,
	"./logo_grnsw": 28,
	"./logo_grnsw.png": 28
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77;